module.exports = __webpack_public_path__ + "img/40k-giveaway-desktop.24ef654.jpg";